import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiHelperService } from '../../core/api-helper.service';
import { ErrorContext, ServerError } from '../errors/error.model';
import { Group } from './group.model';

class GroupFetchError extends ServerError {
    constructor(msg: string, ctx?: ErrorContext) {
        super(msg, ctx);
        this.ctx.userMessage = 'We could not fetch the groups for this organization. Support has been notified.';
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupService {

    constructor( private api: ApiHelperService) {}

    options = { authenticate: true, setRoot: true };

    createGroup(group: Partial<Group>): Promise<Group> {
        return this.api.apiCallSane('/group',
            'PUT',
            this.api.getDefaultHeaders(),
            null,
            group,
            this.options
        ).then((g: Group) => new Group(g));
    }

    getGroupById(id: string): Promise<Group> {
        return this.api.apiCallSane(
            '/group',
            'GET',
            this.api.getDefaultHeaders(),
            { id },
            null,
            this.options
        ).then((g: Group) => new Group(g));

    }

    updateGroup(id: string, group: Partial<Group>): Promise<Group> {
        const headers: HttpHeaders = this.api.getDefaultHeaders();
        return this.api.apiCallSane('/group',
            'PATCH',
            headers,
            { id },
            group,
            this.options
        ).then((g: Group) => new Group(g));
    }

    getAllGroups(): Promise<Group[]> {
        const headers: HttpHeaders = this.api.getDefaultHeaders();
        return this.api.apiCallSane('/groups',
            'GET',
            headers,
            null,
            null,
            this.options
        ).then((pgs: Partial<Group>[]) => pgs.map(pg => new Group(pg)));
    }

    getOrganizationGroups(organizationId: string): Promise<Group[]> {
        const headers: HttpHeaders = this.api.getDefaultHeaders();
        return this.api.apiCallSane('/groups',
            'GET',
            headers,
            { organizationId },
            null,
            this.options
        ).then((pgs: Partial<Group>[]) => pgs.map(pg => new Group(pg)))
        .catch(e => { throw GroupFetchError.upgrade(e); });
    }
}
